import { createIcon } from '@chakra-ui/react'

export const CloseCircle = createIcon({
  displayName: 'CloseCircle',
  viewBox: '0 0 20 20',
  d: 'M10.0001 0C4.47006 0 6.10352e-05 4.47 6.10352e-05 10C6.10352e-05 15.53 4.47006 20 10.0001 20C15.5301 20 20.0001 15.53 20.0001 10C20.0001 4.47 15.5301 0 10.0001 0ZM10.0001 18C5.59006 18 2.00006 14.41 2.00006 10C2.00006 5.59 5.59006 2 10.0001 2C14.4101 2 18.0001 5.59 18.0001 10C18.0001 14.41 14.4101 18 10.0001 18ZM13.5901 5L10.0001 8.59L6.41006 5L5.00006 6.41L8.59006 10L5.00006 13.59L6.41006 15L10.0001 11.41L13.5901 15L15.0001 13.59L11.4101 10L15.0001 6.41L13.5901 5Z',
})
